"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValueListRow = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const debounce_1 = __importDefault(require("debounce"));
const form_value_list_row_utils_1 = require("./form-value-list-row.utils");
const partials_1 = require("../partials");
const hooks_1 = require("../../../../../hooks");
exports.FormValueListRow = react_1.default.memo(({ index, style, data }) => {
    var _a;
    const { items, name, setSize, lastElementRef, onRemove, duplicateIndices } = data, itemProps = __rest(data, ["items", "name", "setSize", "lastElementRef", "onRemove", "duplicateIndices"]);
    const currentEntry = items[index];
    const originalIndex = (0, form_value_list_row_utils_1.getOriginalValueIndex)(currentEntry);
    const isDuplicate = (_a = duplicateIndices === null || duplicateIndices === void 0 ? void 0 : duplicateIndices.has(originalIndex)) !== null && _a !== void 0 ? _a : false;
    const onResize = (0, react_1.useCallback)((element) => {
        if (element) {
            setSize(index, (0, form_value_list_row_utils_1.getMeasuredValueRowHeight)(element));
        }
    }, [index, setSize]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleResize = (0, react_1.useCallback)((0, debounce_1.default)(onResize, 0), []);
    const containerRef = (0, hooks_1.useResizeObserver)(handleResize);
    const onRemoveClick = (0, react_1.useCallback)(() => onRemove(originalIndex), [onRemove, originalIndex]);
    const rowStyle = (0, form_value_list_row_utils_1.getOffsetRowStyle)(style);
    if (currentEntry.type === 'divider') {
        return (react_1.default.createElement("div", { className: "value-form-list-divider-row", style: (0, form_value_list_row_utils_1.getDividerRowStyle)(style) }, react_1.default.createElement(material_1.Divider, { className: "value-form-list-divider" })));
    }
    if (currentEntry.type === 'sectionLabel') {
        return (react_1.default.createElement("div", { className: "value-form-list-section-label-row", style: style }, react_1.default.createElement("span", { className: "value-form-list-section-label" }, currentEntry.label)));
    }
    if (currentEntry.type === 'loadMore') {
        return react_1.default.createElement("div", { ref: lastElementRef, className: "form-section-load-more-sentinel", style: style });
    }
    const { value: currentItem } = currentEntry;
    return (react_1.default.createElement("div", { style: rowStyle }, react_1.default.createElement(partials_1.AttributeFormListItem, Object.assign({ key: index, ref: containerRef, itemLabel: currentItem.name, name: `${name}.${originalIndex}`, readonly: currentItem.readonly, onRemoveClick: onRemoveClick, isDuplicate: isDuplicate }, itemProps))));
});
exports.FormValueListRow.displayName = 'FormValueListRow';
